import ConversionFormWithModal from '../../auto/components/Forms/PerformanceConversionFormModal/FormApp';
import ShowcaseNewVehiclesCarousel from '../../auto/components/Carousels/ShowcaseNewVehicles/index';
import WhatsAppFormWithModal from '../../auto/components/Forms/Whatsapp/PerformanceWhatsappForm/FormApp';
import PerformanceGalleriesSwitch from '../../auto/components/PerformanceGalleriesSwitch';
import VehicleDetailsNewVehiclesCarousel from '../../auto/components/Carousels/UnifiedLaunches/VehicleDetailsNewVehicles/index';
import VehicleDetailsModal from '../../auto/components/Modals/VehicleDetailsModal';
import RotationView from '../../auto/components/RotationView';
import VersionComparison from '../../auto/components/VersionComparison/VersionComparison';
import FeaturesDisplay from '../../auto/components/Cards/DDM/FeaturesDisplay';
import FcaCard from '../../auto/components/Cards/Fca';

(() => {
  // Adicione aqui chaves:valor com os componentes que serão atribuídos ao escopo
  // global. Não passe eles pelo hyperscript (h) aqui pois a página que os usa
  // é quem deve compilá-lo com os pros.
  const components = {
    ConversionFormWithModal,
    WhatsAppFormWithModal,
    ShowcaseNewVehiclesCarousel,
    PerformanceGalleriesSwitch,
    VehicleDetailsNewVehiclesCarousel,
    VehicleDetailsModal,
    RotationView,
    VersionComparison,
    FeaturesDisplay,
    FcaCard,
  };

  Object.keys(components).forEach(c => {
    window[c] = components[c];
  });
})();
